module.exports = __webpack_public_path__ + "static/media/tambah.941ff9db.svg";